import React from 'react';
import { useNavigate } from 'react-router-dom';

const ClientCasesPage = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-800">Client Cases Page</h1>
        <p className="text-gray-600 mt-2">Redirecting to new dashboard...</p>
        <button
          onClick={() => navigate('/client/dashboard')}
          className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default ClientCasesPage;